import { gql } from '@apollo/client';

export const RESET_IDOLOGY = gql`
mutation resetIdentityVerification($userUUID: String!) {
  resetIdentityVerification(userUUID: $userUUID) {
      uuid
      status
  }
}
`;